<template lang="pug">
  include /mixins
  +b.ds-panel--space_2xl.relative
    ui-loader(v-if='load || cartIsLoad')
    +e.element
      //- template(v-if='(cart.hasOwnProperty("quantity") || cart.groups.length) && !load')
      template(v-if='(cart.quantity || cart.groups.length) && !load')
        +b.g-row.--space_xl.--appearance_spaced
          +b.g-cell.g-cols--12.--7-lg
            template(v-if='cart.quantity || cart.groups.length')
              +b.tt-cart-page-block(v-if='hasPartnersInGrops')
                +b.tt-cart-info-block
                  +e.icon.tt-space_mr--3.IMG(src='/static/img/Info.svg')
                  +e.text
                    +e.title
                      +b.ds-caption--size_2md.--semibold.--color_text-6 {{ _('Зверніть увагу') }}
                    +e.description
                      +b.ds-caption--size_sm.--medium.--color_text-8 {{ _('У вашому кошику є товари партнерів, доставка і оплата здійснюються окремо')}}
              +b.tt-cart-page-block
                +b.g-row.--space_sm.--justify_between.--align_center
                  +b.g-cell.g-cols.--narrow-sm
                    +b.tt-space_mb--6.tt-space_mt--2
                      +b.tt-cart-quatity
                        +e.title {{ _('Товарів') }}{{':'}}
                        +e.value {{ cart.quantity }}
                  +b.g-cell.g-cols.--narrow-sm
                    +b.tt-link--styling_default.--grey.variant_end.A.tt-space_mb--1(
                      href=''
                      @click.prevent='clearCurrentCart'
                    )
                      +e.title.SPAN {{ _('Очистить корзину') }}
                +b.ds-caption--size_2xs.--regular.--color_red(
                  v-if='!cartIsValid'
                ) {{ _('В корзине есть товары, которых нет в необходимом Вам количестве') }}
                +b.ds-caption--size_2xs.--regular.--color_red(
                  v-if='!cart.total_price'
                ) {{ _('Добавьте платный товар в корзину, чтобы продолжить оформление заказа') }}
                //- .relative
                //-   +b.line-h--light
                +b.tt-cart-wrapper.--scroll-lock
                  cart-product(
                    v-for='(product, idx) in cart.groups'
                    :key='idx',
                    :product='product',
                    @update:cart='updateEntities($event)'
                  )
                    template(
                      #default='{ removeFromCart, updateCart, isProductload }'
                    )
                      cart-product-ui(
                        :product='product',
                        :load='isProductload'
                        @removeFromCart='removeFromCart',
                        @updateCart='updateCart',
                      )
                  template(v-for='set, idx in cart.sets')
                    cart-set-ui(
                      :classes="'tt-card-product-page-inner tt-card-product-page-inner--space_none'"
                      :key='`et_${idx}`',
                      :set='set',
                      :isSetCard='true'
                      :id='idx'
                      @update:cart='updateEntities($event)'
                      @load:change='changeLoad'
                    )

                  //- cart-product(
                  //-   v-for='(product, idx) in cart.gifts_groups'
                  //-   :key='idx',
                  //-   :product='product',
                  //-   @update:cart='updateEntities($event)'
                  //- )
                  //-   template(
                  //-     #default='{ removeFromCart, updateCart, isProductload }'
                  //-   )
                  //-     cart-gifts-ui(
                  //-       :product='product',
                  //-       :load='isProductload'
                  //-       @removeFromCart='removeFromCart',
                  //-       @updateCart='updateCart',
                  //-     )
              template(v-for='set, idx in cart.sets')
                +b.tt-cart-page-block(v-if="cart.gifts[idx]")
                  cart-set-ui(
                    :classes="'tt-card-product-page-inner tt-card-product-page-inner--space_none'"
                    :key='`et_${idx}`',
                    :set='set',
                    :id='idx'
                    :key-for-reload="cart.quantity"
                    @update:cart='updateEntities($event)'
                    @load:change='changeLoad'
                  )
              template(
                v-for='(products, idx) in cart.sales_groups'
              )
                template(
                  v-for='(product, product_idx) in products'
                )
                  cart-product(
                    v-if="!product.relations.length"
                    :key='`${idx}_${product.id}`',
                    :product='product',
                    @update:cart='updateEntities($event)'
                  )
                    template(
                      #default='{ removeFromCart, updateCart, isProductload }'
                    )
                      +b.tt-cart-page-block
                        div
                          cart-campaign-ui(
                            :product='product',
                            :load='isProductload'
                            :is-simple="true"
                            @removeFromCart='removeFromCart',
                            @updateCart='updateCart',
                            :show-gifts='!product_idx'
                          )
              template(v-if="hasCampaigns")
                +b.tt-cart-page-block
                  campaigns-spoilers(
                    :groups="cart.groups"
                    :sets="cart.sets"
                  )
          +b.g-cell.g-cols--12.--5-lg
            template(v-if='cart.quantity || cart.groups.length') 
              +b.tt-cart-page-block
                template(v-if="cart.cross_sales && cart.cross_sales.length")
                  template(v-for="item in cart.cross_sales")
                    +b.tt-space_mt--4.tt-space_mb--4.g-row.--space_none.--justify_between.pointer(
                      :key="item.id"
                      @click.prevent="openAdditionalProducts('dynamic', item)"
                    )
                      cell(
                          cols='narrow',
                        )
                        +b.tt-space_mr--3.flex_centered
                          +b.cross-sales-icon.IMG(:src='item.props.icon')
                      cell(
                          cols='auto',
                        )
                        +b.ds-caption.--size_2md.--semibold.P {{ item.props.button_text }}
                      cell(
                          cols='narrow',
                        )
                        +b.flex_centered
                          svg(width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg")
                            path(d="M12 3V21M3 12H21" stroke="#1E1E1E" stroke-width="2")
                  +b.line-h--light
                template(v-if="offerPackage")
                  +b.tt-space_mt--4.tt-space_mb--4.g-row.--space_none.--justify_between.pointer(
                    @click.prevent="openAdditionalProducts('package', null)"
                  )
                    cell(
                        cols='narrow',
                      )
                      +b.tt-space_mr--3.flex_centered
                        svg(width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg")
                          path(d="M19 5.5H5C4.17157 5.5 3.5 6.17157 3.5 7V21C3.5 21.8284 4.17157 22.5 5 22.5H19C19.8284 22.5 20.5 21.8284 20.5 21V7C20.5 6.17157 19.8284 5.5 19 5.5Z" stroke="#1E1E1E" stroke-width="1.5" stroke-linejoin="round")
                          path(d="M15.5 9.5V5.5C15.5 4.97471 15.4095 4.45457 15.2336 3.96927C15.0577 3.48396 14.7999 3.04301 14.4749 2.67157C14.1499 2.30014 13.764 2.0055 13.3394 1.80448C12.9148 1.60346 12.4596 1.5 12 1.5C11.5404 1.5 11.0852 1.60346 10.6606 1.80448C10.236 2.0055 9.85013 2.30014 9.52513 2.67157C9.20012 3.04301 8.94231 3.48396 8.76642 3.96927C8.59053 4.45457 8.5 4.97471 8.5 5.5L8.5 9.5" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round")

                    cell(
                        cols='auto',
                      )
                      +b.ds-caption.--size_2md.--semibold.P {{ _('Додати упаковку') }}
                    cell(
                        cols='narrow',
                      )
                      +b.flex_centered
                        svg(width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg")
                          path(d="M12 3V21M3 12H21" stroke="#1E1E1E" stroke-width="2")
                +b.line-h--light.tt-space_mb--8
                +b.tt-space_mt--6.tt-space_mb--6.g-row.--appearance_spaced.ROW(
                    align='start'
                    v-if='freeShippingMessage'
                  )
                  cell(cols="narrow")
                    +b.ds-caption.P
                      span.icon-shipping-car
                  cell(cols="auto")
                    +b.ds-caption--size_sm.P {{ freeShippingMessage }}
                +b.tt-card-product-page-inner.--light-bg.card-product-inner.relative
                  cart-conflicts(
                    :conflicts='cart.calc_strategy_campaigns'
                    :trip='cart.trip'
                    @loadChange='changeLoad'
                    v-if='allowOrderTrips'
                  )
                  +b.tt-space_pb--2.ROW(justify='end')
                    cell(
                      cols='12',
                    )
                      template(
                        v-if='cart.cart_bonus_sum'
                      )
                        +b.tt-space_mb--5.ROW(
                          justify='between',
                          align='center',
                          appearance='nowrap'
                        )
                          cell(
                            cols='auto'
                          )
                            +b.ds-caption.--size_2md.--size_3md-xl.--medium.P {{ _('Очікувана сума кешбеку') }}
                          cell(
                            cols='narrow'
                          )
                            +b.tt-cart-cashback-value.--base
                              row(align='center' space="xs")
                                cell
                                  +b.cashback-percent--only-icon
                                    +e.icon.SVG(:title='_("cashback")' xmlns='http://www.w3.org/2000/svg', width='20', height='20', viewBox!='0 0 20 20', fill='none')
                                      circle(cx='10' cy='10' r='10' fill='#FF7A00')
                                      circle(cx='10' cy='10' r='8.5' fill='#FF7A00' stroke='white')
                                      path(d='M10.5398 15C9.74432 15 9.00568 14.8816 8.32386 14.6448C7.65152 14.3989 7.06439 14.0528 6.5625 13.6066C6.07008 13.1603 5.68655 12.6321 5.41193 12.0219C5.13731 11.4117 5 10.7377 5 10C5 9.2623 5.13731 8.58834 5.41193 7.97814C5.68655 7.36794 6.07008 6.83971 6.5625 6.39344C7.06439 5.94718 7.65152 5.60565 8.32386 5.36885C9.00568 5.12295 9.74432 5 10.5398 5C11.5152 5 12.3769 5.16393 13.125 5.4918C13.8826 5.81967 14.5076 6.29326 15 6.91257L12.8835 8.72951C12.59 8.37432 12.2633 8.10109 11.9034 7.90984C11.553 7.70947 11.1553 7.60929 10.7102 7.60929C10.3598 7.60929 10.0426 7.66393 9.75852 7.77322C9.47443 7.88251 9.22822 8.04189 9.01989 8.25137C8.82102 8.46084 8.66477 8.71585 8.55114 9.01639C8.4375 9.30783 8.38068 9.6357 8.38068 10C8.38068 10.3643 8.4375 10.6967 8.55114 10.9973C8.66477 11.2887 8.82102 11.5392 9.01989 11.7486C9.22822 11.9581 9.47443 12.1175 9.75852 12.2268C10.0426 12.3361 10.3598 12.3907 10.7102 12.3907C11.1553 12.3907 11.553 12.2951 11.9034 12.1038C12.2633 11.9035 12.59 11.6257 12.8835 11.2705L15 13.0874C14.5076 13.6976 13.8826 14.1712 13.125 14.5082C12.3769 14.8361 11.5152 15 10.5398 15Z' fill='white')
                                cell
                                  +b.ds-caption--size_2md.--semibold.P(
                                    style='line-height: 1;'
                                    v-html='getSplittedHtml(cart.cart_bonus_sum)'
                                  )
                      template(
                        v-if='cart.total_gift_prices'
                      )
                        +b.tt-space_mt--4.tt-space_mb--6.ROW(
                          justify='between',
                          align='center',
                        )
                          cell(
                            cols='narrow'
                          )
                            +b.ds-caption--size_sm.--regular.P {{ _('Стоимость подарков') }}
                          cell(
                            cols='narrow'
                          )
                            row(align='center')
                              cell
                                +b.ds-caption--size_sm.--regular.P(
                                  style='line-height: 1;'
                                  v-html='getSplittedHtml(cart.total_gift_prices)'
                                )
                      +b.ROW(
                        justify='between'
                        align='center',
                      )
                        cell(
                          cols='5 4-xl'
                        )
                          +b.ds-caption--size_3md.--color_grey.--semibold.--lh_25.P {{ _('Разом до оплати:') }}
                        cell(
                          cols='auto 8-xl'
                        )
                          row
                            cell(
                              cols='12'
                            )
                              +b.ds-caption--size_lg.--appearance_right.--color_grey.--semibold.P(v-html='getSplittedHtml(getTotalPrice)')
                            cell(
                              cols='12'
                            )
                              ui-currency-converter.ds-caption--appearance_right(
                                :key="getTotalPrice"
                                :price='getTotalPrice'
                                :site-currency="current_site_currency"
                                :national-currency="national_currency"
                                :national-currency-symbol="national_currency_symbol"
                              )
                      template(
                        v-if='cart.parameters.promocode_title && cart.promocode_discount_summ'
                      )
                        +b.tt-space_mt--4.ROW(
                          justify='between',
                          align='center',
                        )
                          cell(
                            cols='narrow'
                          )
                            +b.ds-caption--size_sm.--color_red.--regular.P {{ _('Скидка по промокоду') }} {{ cart.parameters.promocode_title }}
                          cell(
                            cols='narrow'
                          )
                            +b.ds-caption--size_sm.--color_red.--regular.P(
                              v-html='getSplittedHtml(cart.promocode_discount_summ)'
                            )

                      template(
                        v-if='cart.parameters.discount_from_sum_limit_action_by_items && hasGlobalDiscountFromSum'
                      )
                        +b.tt-space_mt--4.ROW(
                          justify='between',
                          align='center',
                        )
                          cell(
                            cols='narrow'
                          )
                            +b.ds-caption--size_sm.--color_red.--regular.P {{ _('Скидка по акции:') }}
                          cell(
                            cols='narrow'
                          )
                            +b.ds-caption--size_lg.--color_red.--regular.P  {{ hasGlobalDiscountFromSum && hasGlobalDiscountFromSum.base.parameters.discount_amount }} %
                      template(
                        v-if='cart.parameters.site_discount'
                      )
                        +b.tt-space_mt--4.ROW(
                          justify='between',
                          align='center',
                        )
                          cell(
                            cols='narrow'
                          )
                            +b.ds-caption--size_sm.--color_red.--regular.P {{ _('Скидка при покупке online:') }}
                          cell(
                            cols='narrow'
                          )
                            +b.ds-caption--size_lg.--color_red.--regular.P  {{ cart.parameters.site_discount }} %
                      +b.tt-space_mt--4.ROW(
                        align='center',
                        v-if='cart.parameters.promocode_title && cart.promocode_discount_summ || cart.parameters.site_discount || cart.parameters.discount_from_sum_limit_action_by_items && hasGlobalDiscountFromSum'
                        justify='between'
                      )
                        cell(
                          cols='narrow'
                        )
                          +b.ds-caption--size_sm.--color_red.--medium.P {{ _('Сумма со скидкой:') }}
                        cell(
                          cols='narrow'
                        )
                          +b.ds-caption--size_lg.--color_red.--semibold.P(
                            v-html='getSplittedHtml(cart.total_price)'
                          )
                  +b.tt-space_mt--5.ROW.g-row--appearance_column-reverse-till-sm.--appearance_spaced(
                    justify='center'
                    align='center'
                    appearance='nowrap'
                    v-if='isFully'
                  )
                    //- cell(cols='auto 4-md 6-xl')
                    //-   +b.tt-link--accent.--appearance_underline.--variant_start.BUTTON.ds-caption--size_sm.is-disable-xl(
                    //-     @click.prevent='$emit("close")'
                    //-   )
                    //-     +e.title.P() {{ _(' Продолжить покупки') }}
                    //-   .is-visible-xl
                    //-     +b.tt-button--bordered_modern.--fixed-h.BUTTON(
                    //-       @click.prevent='$emit("close")'
                    //-     )
                    //-       +e.title.P() {{ _(' Продолжить покупки') }}
                    cell(cols='12')
                      +b.tt-button.BUTTON.ds-caption--size_2xs.--size_sm-xl(
                        @click.prevent='nextStep'
                        :disabled='!cartIsValid  || !cart.total_price'
                      )
                        +e.title.P() {{ _('оформити замовлення') }}
                  +b.tt-space_mt--5.ROW(
                    justify='between'
                    align='start'
                    appearance='nowrap'
                    v-if='!isFully'
                  )
                    cell(cols='12')
                      +b.tt-button--fixed-h.BUTTON.ds-caption--size_2xs.--size_sm-xl(
                        @click.prevent='$emit("close"); promise(true)'
                        :disabled='!cartIsValid || !cart.total_price'
                      )
                        +e.title.P() {{ _('оформити замовлення') }}

                      +b.tt-link--styling_default.A.tt-space_mt--4(
                        @click.prevent='triggerOneClickOrder'
                      )
                        +e.title.SPAN {{ _('Замовити в один клік') }}
                  transition(name='slidedown')
                    +b.tt-space_mt--4(v-if='isOneClickOrderAvailable')
                      one-click-order
            //- template(v-else)
            //-   +b.tt-space_mt--10.ROW(
            //-     justify='center',
            //-     align='center',
            //-     appearance='column'
            //-   )
            //-     cell(cols='12 5-xl')
            //-       +b.ds-caption--size_lg.--medium.--appearance_center.H2 {{ _('Ваш кошик для покупок поки що порожній') }}
            //-     +b.tt-space_mt--10.tt-space_mb--10.CELL(cols='12 5-xl')
            //-       +b.tt-button.BUTTON(
            //-         @click.prevent='$emit("close")'
            //-       )
            //-         +e.title.P() {{ _(' Продолжить покупки') }}
      template(v-else)
        +b.tt-empty-cart-block
          +b.tt-space_mt--8.ROW(
            v-if="!load || !cartIsLoad"
            justify='center',
            align='center',
            appearance='column'
          )
            cell(cols='narrow')
              +b.tt-empty-cart-image-block
                +e.image.IMG(src='/static/img/EmptyCart.svg')
          +b.tt-space_mt--8.ROW(
            v-if="!load || !cartIsLoad"
            justify='center',
            align='center',
            appearance='column'
          )
            cell(cols='12 5-xl')
              +b.ds-caption--size_2md.--medium.--appearance_center.H2 {{ _('Ваш кошик поки що порожній') }}
            +b.tt-space_mt--6.tt-space_mb--6.CELL(cols='narrow')
              +b.tt-button.BUTTON(
                @click='toCatalog()'
              )
                +e.title.P() {{ _(' Продолжить покупки') }}
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { addCartCoupon } from '@api/cart.service'
import CartProductUi from '@app/Cart/ProductUi'
import CartProduct from '@app/Cart/Product'
import CartGiftsUi from '@app/Cart/GiftsUi'
import PackagesView from '@app/Cart/PackagesView'
import CartSetUi from '@app/Cart/SetUi'
import CartConflicts from '@app/Cart/Conflicts.vue'
import CampaignsSpoilers from '@app/Cart/CampaignsSpoilers.vue'
import OneClickOrder from '@app/Purchase/OneClickOrder'
import analyticCartView from '@analytic/cart'
import { confirmWithPromise } from '@utils/helpers'

import {
  isConfigAllowed,
} from '@utils/decor'

export default {
  name: 'CartPage',
  props: {
    isFully: {
      type: Boolean,
      default: true,
    },
    promise: {},
    retrieve: {
      default: true,
    },
  },
  components: {
    CartProduct,
    CartProductUi,
    OneClickOrder,
    CartSetUi,
    CartGiftsUi,
    CartConflicts,
    CampaignsSpoilers
  },
  data() {
    return {
      current_site_currency: window.current_site_currency,
      national_currency: window.national_currency,
      national_currency_symbol: window.national_currency_symbol,
      order_page: window.order_page,
      currency: window.currency,
      index_page: window.baseUrl,
      oneClickOrderEnabled: window.is_one_click_order_enabled,
      show: false,
      load: true,
    }
  },
  computed: {
    ...mapState('cart', [
      'cart', 'coupon', 'hasPackages', 'cartIsLoad',
    ]),
    ...mapState('staff', [
      'level',
    ]),
    ...mapGetters('cart', [
      'cartIsValid',
    ]),
    hasPartnersInGrops() {
      const groups = this.cart.groups || [];
      const hasWithSellerId = groups.some(el => el?.base?.element.props.product.props.brand.props.is_partner);
      console.log("🚀 ~ hasWithSellerId:", hasWithSellerId)
      const hasWithoutSellerId = groups.some(el => !el?.base?.element.props.product.props.brand.props.is_partner);
      console.log("🚀 ~ hasWithoutSellerId:", hasWithoutSellerId)
      const hasSetsWithoutSellerId = Object.values(this.cart.sets).some(arr => Array.isArray(arr) && arr.some(
          el => !el?.base?.element?.props?.product?.props?.brand?.props?.is_partner
        )
      );
      console.log("🚀 ~ hasSetsWithoutSellerId:", hasSetsWithoutSellerId)
      return hasWithSellerId && hasWithoutSellerId || hasWithSellerId && hasSetsWithoutSellerId;
    },
    hasCampaigns() {
      return this.cart.groups.some(el => el.base.parameters.campaigns)
    },
    hasGlobalDiscountFromSum() {
      return this.cart.groups.find(el => el.base.parameters.is_global_condition)
    },
    getTotalPrice() {
      return this.hasGlobalDiscountFromSum || this.cart.parameters && this.cart.parameters.promocode_title && this.cart.promocode_discount_summ ? this.cart.total_price_without_discounts : this.cart.total_price_without_site_discount
    },
    isOneClickOrderAvailable() {
      return window.authent ? this.level?.props?.allow_one_click_order : window.allow_one_click_order_for_anonim
    },
    freeShippingMessage() {
      return window.authent ? this.level?.props?.free_shipping_information : window.free_shipping_information_for_anonim
    },
    offerPackage() {
      const globalCondition = window.authent ? this.level?.props?.offer_package : window.offer_package_for_anonim
      // const hasPackageInCart = this.cart.has_package
      const sellerIds = this.cart.seller_ids.includes(null)
      return globalCondition && sellerIds
    },
    allowOrderTrips() {
      return isConfigAllowed('allow_order_trips')
    },
  },
  watch: {
    cartIsValid: {
      handler(nval) {
        // if (this.promise && nval) {
        //   this.promise(nval)
        //   this.$emit('close')
        // }
      },
      deep: true,
    },
  },
  async created() {
    if (!this.retrieve) {
      this.load = false
      await this.getCartAdditionalFeatures()
      return
    }
    this.getCart().then(async () => {
      this.load = false
      await this.getCartAdditionalFeatures()
    })
  },
  mounted() {

  },
  methods: {
    ...mapActions('cart', [
      'getCart', 'getPackages', 'clearCart',
    ]),
    ...mapActions('staff', [
      'getUserLevelSettings',
    ]),
    toCatalog() {
      window.location.href = '/catalog/'
    },
    openAdditionalProducts(type, item) {
      const pr = arg => new Promise((resolve, reject) => {
        if (arg) {
          resolve(arg)
          return
        }
        reject(new Error('Promise is rejected'))
      }).then(res => {
        this.getCart()
      })
      this.$modal.show(
        PackagesView,
        {
          promise: pr,
          type,
          item,
          params: { 
            category: item ? item.props.categories_propose.join(', ') : ''
          }
        }, {
          height: 'auto',
          classes: ['package-modal'],
          adaptive: true,
          scrollable: true,
        }
      )
    },
    toPromise(arg) {
      if (!arg) return Promise.reject()

      return Promise.resolve(arg)
    },
    async getCartAdditionalFeatures() {
      if (this.cart.groups) {
        console.log("🚀 ~ this.cart.groups:", this.cart)
        analyticCartView(this.cart.groups)
      }
      if (window.authent) {
        await this.getUserLevelSettings()
        if (this.offerPackage) this.getPackages()
        return
      }
      if (this.offerPackage) this.getPackages()
    },
    openPackage() {
      const pr = f => this.toPromise(f)
        .then(() => {
          this.initCheckout()
        })
      this.$modal.show(
        () => import('@app/Cart/PackagesView'),
        {
          promise: pr,
        }, {
          height: 'auto',
          classes: ['cart-modal'],
          adaptive: true,
          scrollable: true,
          clickToClose: false,
        }
      )
    },
    nextStep() {
      // if (this.offerPackage && this.hasPackages) {
      //   this.openPackage()
      //   return
      // }
      this.initCheckout()
    },
    initCheckout() {
      window.location.href = this.order_page
    },
    triggerOneClickOrder() {
      this.show = !this.show
    },
    async clearPromo() {
      const question = this._('Вы действительно хотите отменить примененный промокод?')

      await confirmWithPromise(question, this)
      return addCartCoupon.execute({}, { title: null })
        .then(() => {
          this.getCart()
        })
    },
    async clearCurrentCart() {
      const question = this._('Вы действительно хотите очистить корзину?')

      await confirmWithPromise(question, this)
      return this.clearCart()
    },
    changeLoad(event) {
      console.log(event, '.>>>`    changeLoad(event) 1>>>>>>>>');
      this.load = event
    },
    dddd(event) {
      console.log(event, '.>>>`    cha111111111111111ngeLoad(event) 1>>>>>>>>');
      this.load = event
    },
  },
}
</script>
